import type {
  DocumentSchema,
  SearchResponseHit,
} from 'typesense/lib/Typesense/Documents';

/**
 * Removes duplicate search hits using a caller-provided key extractor.
 * The Typesense document `id` for *WithEngagement collections is a
 * slug-prefixed composite (e.g. `relaxing_4401`) and leaks into the SSR
 * payload as a crawlable path. Callers pass the right stable identifier
 * (`track_id` for music, `sfx_variant_id` for sfx) so we both dedupe
 * correctly across category contexts and avoid relying on the leaky `id`.
 *
 * Hits with a missing or empty key are excluded.
 */
export function deduplicateSearchHits<T extends DocumentSchema>(
  hits: SearchResponseHit<T>[],
  getKey: (document: T) => string | number | undefined
): SearchResponseHit<T>[] {
  const seen = new Set<string | number>();
  return hits.filter((hit) => {
    if (!hit.document) {
      return false;
    }
    const key = getKey(hit.document);
    if (key === undefined || key === null || key === '' || seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
}
